module.exports = __webpack_public_path__ + "static/img/1.12dd904.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/1.png
// module id = BLDA
// module chunks = 0